import { computed, defineComponent, inject, PropType } from 'vue'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { Store } from 'pinia'
import PopupDragView from './popupDragView'
import { ChargeMapContext } from '../chargerMap/index.model'

export default defineComponent({
  name: 'popup-drag',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    showSummary: {
      type: Boolean,
      default: true,
    },
  },
  emits: [],
  setup: (props) => {
    // 最外层做渲染判断
    const client = inject<string>('client', '')
    const needRenderComponent = computed(() => client === 'mobile')
    const componentStore = computed(() => props.componentStore)
    // const showSummary = computed(() => props.showSummary)
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    !componentsConfig?.data_default?.show && props.componentStore.bus.emit('hideSummary')
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)

    return () => (
      <>
        {needRenderComponent.value && (
          <>
            <PopupDragView
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></PopupDragView>
          </>
        )}
      </>
    )
  },
})
